import { useContext } from "react";
import { Redirect, Route } from "react-router";

import { hasPermission } from "../../utils/permissions";
import { Context } from "../../context/globalContext";
import api from "../../services/api";
import PermissionDeniedComponent from "../PermissionDenied";

export default function CustomRoute({
  isPrivate,
  permissions,
  path,
  exact,
  component,
}) {
  const { authenticated } = useContext(Context);

  const tokenData = JSON.parse(localStorage.getItem("tokenData") || "{}");

  api.defaults.headers.Authorization = tokenData.access_token
    ? `Bearer ${tokenData.access_token}`
    : "";

  /* if (isLoading) {
    return <h1>Loading...</h1>;
  }
 */

  if (isPrivate && !authenticated) {
    return <Redirect to="/" />;
  }

  if (permissions && !hasPermission(permissions)) {
    return <PermissionDeniedComponent />;
  }

  return <Route path={path} exact={exact} component={component} />;
}
